import { NgModule } from '@angular/core';
import { ControlErrorComponent } from './control-error.component';
import { ControlErrorHandlerDirective } from './control-error-handler.directive';
import { FormErrorHandlerDirective } from './form-error-handler.directive';

const parts = [
  ControlErrorComponent,
  ControlErrorHandlerDirective,
  FormErrorHandlerDirective,
];

@NgModule({
  imports: parts,
  exports: parts,
})
export class FormErrorHandlerModule {}
